import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";

import { DropDown } from "../../Common";
import { Icon } from "./../../Common/Icon";

export default class PanelHeaderDropdown extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    items: PropTypes.array
  };

  static defaultProps = {
    isOpen: false,
    items: []
  };

  render() {
    return (
      <Fragment>
        <Icon className="panel-header__arrow-down" id="arrow-down" />
        <DropDown className="panel-dropdown__dropdown" contentTag="menu" isOpen={this.props.isOpen}>
          {this.props.items.map(item => (
            <li key={item.label}>
              <button className="panel-dropdown__heading-link" onClick={() => item.onClick(item.id)}>
                {item.label}
              </button>
            </li>
          ))}
        </DropDown>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelHeaderDropdown.js